import { keyframes, styled } from 'styled-components';

import { ButtonOrLink } from '#/components/ButtonOrLink/ButtonOrLink';
import { colors, spacing } from '#/theme/theme';

const aSlideLTRBackground = keyframes`
  from {
    clip-path: inset(0 100% 0 0);
  }
  to {
    clip-path: inset(0 0 0 0);
  }
`;

export const SubmissionsButton = styled(ButtonOrLink)`
  background-color: ${colors.selectionGrey} !important;
  border-radius: 8px;
  letter-spacing: 0.5px;
  font-size: 16px;
  padding: 8px 16px;
  border: none;
  color: ${colors.mediumContentGrey} !important;
  line-height: 1;
  height: 39px;
  position: relative;
  overflow: hidden;
  transition: clip-path;

  > div {
    align-items: center;
    gap: ${spacing[6]};
  }

  &::after {
    align-items: center;
    background-color: ${colors.brandGreen};
    clip-path: inset(0 100% 0 0);
    color: white;
    display: flex;
    justify-content: center;
    content: 'Submissions';
    height: 100%;
    position: absolute;
    width: 100%;
    top: 0;
    right: 0;
  }

  &[data-active]::after {
    animation: ${aSlideLTRBackground} 1s forwards;
  }

  &:hover {
    color: ${colors.brandGreen};
  }

  &:disabled {
    opacity: 1;
    overflow: visible;

    &:hover {
      color: initial;
    }
  }
`;
